import { floatingSurface } from './Popover';

// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    backgroundColor: floatingSurface(theme),
                    boxShadow: theme.customShadows.z20,
                },
            },
        },
    };
}
